import React, { useState } from 'react';

const gradeOptions = Array.from({ length: 10 }, (_, index) => String(index + 3));
const languageOptions = ['Hindi', 'English', 'Marathi', 'Punjabi', 'Kannada', 'Telugu'];
const genderOptions = ['Male', 'Female', 'Others'];
const namePattern = /^[A-Za-z][A-Za-z\s.'-]*$/;

function StudentDetailsForm({ formData, handleInputChange, onProceed, onBack, variant = 'basic' }) {
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (variant === 'basic') {
      const trimmedName = formData.student_name.trim();

      if (!trimmedName) {
        newErrors.student_name = 'Student name is required';
      } else if (!namePattern.test(trimmedName)) {
        newErrors.student_name = 'Use letters only. Numbers and emoji are not allowed';
      }

      if (!/^\d{10}$/.test(formData.phone)) {
        newErrors.phone = 'Phone number must be exactly 10 digits';
      }

      if (formData.phone !== formData.confirm_phone) {
        newErrors.confirm_phone = 'Phone numbers do not match';
      }
    }

    if (variant === 'additional') {
      if (!formData.gender) {
        newErrors.gender = 'Gender is required';
      }

      if (!formData.grade) {
        newErrors.grade = 'Grade is required';
      }

      if (!formData.language) {
        newErrors.language = 'Language is required';
      }
    }

    return newErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateForm();
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      onProceed();
    }
  };

  return (
    <form className="student-card-body" onSubmit={handleSubmit}>
      <span className="student-section-title">STUDENT DETAILS</span>
      <p className="student-helper-text">
        {variant === 'basic'
          ? 'Enter the student name and phone number exactly as they should be registered.'
          : 'Enter the remaining student details to complete registration.'}
      </p>

      <div className="student-form-grid">
        {variant === 'basic' && (
          <>
            <label className="student-form-field">
              <span className="student-field-label">STUDENT NAME</span>
              <input
                type="text"
                name="student_name"
                value={formData.student_name}
                onChange={handleInputChange}
                placeholder="Eg: Sonam Kumari"
                className="student-input"
              />
              {errors.student_name && <span className="error">{errors.student_name}</span>}
            </label>

            <label className="student-form-field">
              <span className="student-field-label">PHONE NUMBER</span>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="10 digit mobile number"
                className="student-input"
                maxLength="10"
              />
              {errors.phone && <span className="error">{errors.phone}</span>}
            </label>

            <label className="student-form-field">
              <span className="student-field-label">CONFIRM PHONE NUMBER</span>
              <input
                type="tel"
                name="confirm_phone"
                value={formData.confirm_phone}
                onChange={handleInputChange}
                placeholder="Re-enter the same number"
                className="student-input"
                maxLength="10"
              />
              {errors.confirm_phone && <span className="error">{errors.confirm_phone}</span>}
            </label>
          </>
        )}

        {variant === 'additional' && (
          <>
            <label className="student-form-field">
              <span className="student-field-label">GRADE/STANDARD/CLASS</span>
              <select
                name="grade"
                value={formData.grade}
                onChange={handleInputChange}
                className="student-input"
              >
                <option value="">Select grade</option>
                {gradeOptions.map((grade) => (
                  <option key={grade} value={grade}>
                    {grade}
                  </option>
                ))}
              </select>
              {errors.grade && <span className="error">{errors.grade}</span>}
            </label>

            <label className="student-form-field">
              <span className="student-field-label">GENDER</span>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleInputChange}
                className="student-input"
              >
                <option value="">Select gender</option>
                {genderOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              {errors.gender && <span className="error">{errors.gender}</span>}
            </label>

            <label className="student-form-field">
              <span className="student-field-label">LANGUAGE</span>
              <select
                name="language"
                value={formData.language}
                onChange={handleInputChange}
                className="student-input"
              >
                <option value="">Select language</option>
                {languageOptions.map((language) => (
                  <option key={language} value={language}>
                    {language}
                  </option>
                ))}
              </select>
              {errors.language && <span className="error">{errors.language}</span>}
            </label>
          </>
        )}
      </div>

      <button type="submit" className="student-primary-button">
        <span className="student-primary-button-text">PROCEED</span>
      </button>

      {variant === 'additional' && onBack && (
        <button type="button" className="student-secondary-button" onClick={onBack}>
          <span className="student-secondary-button-text">BACK</span>
        </button>
      )}
    </form>
  );
}

export default StudentDetailsForm;
